import { render } from "./Promocionmf.vue?vue&type=template&id=3b9854d6"
import script from "./Promocionmf.vue?vue&type=script&lang=js"
export * from "./Promocionmf.vue?vue&type=script&lang=js"

import "./Promocionmf.vue?vue&type=style&index=0&id=3b9854d6&lang=css"
import "./Promocionmf.vue?vue&type=style&index=1&id=3b9854d6&lang=css"
import "./Promocionmf.vue?vue&type=style&index=2&id=3b9854d6&lang=css"
import "./Promocionmf.vue?vue&type=style&index=3&id=3b9854d6&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__